module.exports = __webpack_public_path__ + "img/type_text_icon.b6100b1b.svg";